import { CurrencyDescription, CURRENCY_DESCRIPTION, CURRENCY_EXPANSION_DESCRIPTION } from './currency_descriptions';

export default class Currency {
  static get(currencyCode: string): CurrencyDescription {
    return { ...CURRENCY_DESCRIPTION, ...CURRENCY_EXPANSION_DESCRIPTION }[currencyCode];
  }

  static get currencyCodes() {
    return Object.keys(CURRENCY_DESCRIPTION).sort((a, b) => {
      return CURRENCY_DESCRIPTION[a].order - CURRENCY_DESCRIPTION[b].order;
    });
  }

  static isAvailableForDirectCheckoutPayout(currencyCode: string): boolean {
    return INTERNAL_PAYOUTS_SUPPORTED_CURRENCIES.indexOf(currencyCode) >= 0;
  }
}

export function supportedCurrenciesForAdyenPayouts(originCountryCode: string): string[] {
  const currencyToCountryMap: Record<string, string[]> = {
    GB: ['EUR', 'GBP'],
    SE: ['SEK'],
    DK: ['DKK'],
    PL: ['PLN'],
    HU: ['HUF'],
    RO: ['RON'],
    CZ: ['CZK'],
    AU: ['AUD'],
    CH: ['CHF'],
    NO: ['NOK'],
  };


  return currencyToCountryMap[originCountryCode] || ['EUR'];
}

/**
 * Selling/listing supported currencies
 *
 * Some listing currencies are Payment Provider (PayPal or Reverb Payments) dependent
 */
export const LISTING_CURRENCIES = Object.freeze([
  'USD',
  'CAD',
  'EUR',
  'GBP',
  'AUD',
  'JPY',
  'NZD',
  'MXN',
]);

export const REVERB_PAYMENTS_EXPANSION_LISTING_CURRENCIES = Object.freeze([
  'SEK',
  'DKK',
  'PLN',
  'HUF',
  'RON',
  'CZK',
  'CHF',
  'NOK',
]);

/**
 * Supported for payouts by Reverb directly
*/
export const INTERNAL_PAYOUTS_SUPPORTED_CURRENCIES = Object.freeze([
  'USD',
  'CAD',
]);

export const ADYEN_SUPPORTED_CURRENCIES = Object.freeze([
  'EUR',
  'GBP',
]);

export const ADYEN_SUPPORTED_EXPANSION_CURRENCIES = Object.freeze([
  ...ADYEN_SUPPORTED_CURRENCIES,
  'SEK',
  'DKK',
  'PLN',
  'HUF',
  'RON',
  'CZK',
  'CHF',
  'NOK',
  'AUD',
]);

export const PAYPAL_SUPPORTED_CURRENCIES = Object.freeze(LISTING_CURRENCIES);

const SETTLEMENT_TO_PRESENTMENT: { [currencyCode: string]: string[] } = {
  USD: ['USD', 'AUD', 'CAD', 'EUR', 'JPY', 'GBP'],
  CAD: ['CAD'],
  EUR: ['EUR', 'GBP', 'USD'],
  GBP: ['GBP', 'EUR', 'USD'],
};

export function reverbPaymentsPresentmentCurrency(buyerCurrencyCode: string, orderCurrencyCode: string) {
  if (canPresentInBuyerCurrency(buyerCurrencyCode, orderCurrencyCode)) {
    return buyerCurrencyCode;
  }

  return orderCurrencyCode;
}

function canPresentInBuyerCurrency(buyerCurrencyCode: string, orderCurrencyCode: string) {
  return (orderCurrencyCode in SETTLEMENT_TO_PRESENTMENT) &&
    SETTLEMENT_TO_PRESENTMENT[orderCurrencyCode].includes(buyerCurrencyCode);
}
